<template>
  <div>
    <div class="alert alert-success mb-0" v-show="success">{{ success }}</div>
    <div class="alert alert-danger mb-0" v-show="error">{{ error }}</div>
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="row">
          <form id="form" :action="api+'api/v1/create/sub-reseller'">
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.account }} </div>
                <div class="card-block">
                  <div class="form-group">
                    <label for="">{{ t.name }}</label>
                    <input type="text" name="name" class="form-control" maxlength="30" required="" value=""> </div>
                  <div class="form-group">
                    <label for="">{{ t.user.telephone }}</label>
                    <input type="text" name="phone" class="form-control" maxlength="15" value=""> </div>
                  <div class="form-group">
                    <label for="">{{ t.details }}</label>
                    <textarea name="detail" class="form-control" rows="5"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.details }} </div>
                <div class="card-block">
                  <div class="form-group">
                    <label for="">{{ t.user.username }}</label>
                    <input type="text" name="username" class="form-control" maxlength="20" required="" value=""> </div>
                  <div class="form-group">
                    <label for="">{{ t.user.password }}</label>
                    <div class="input-group">
                      <input type="text" v-model="password" class="form-control" name="password" maxlength="20" required="" value="">
                      <span class="input-group-btn">
                        <button class="btn btn-link" type="button" id="generatePassword" @click="generatePasswordFx">{{ t.custom_reseller_panel.generate_password }}</button>
                      </span>
                    </div>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="active" checked=""> {{ t.custom_reseller_panel.is_active }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="card card-block">
                <button type="submit" class="btn btn-success" id="form-submit-button">{{ t.edit_and_save }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminCreate",
  data () {
    return {
      api: window.api,
      t: this.$root.t,
      error: null,
      success: null,
      password: null
    }
  },
  mounted() {
    this.submitForm()
  },
  methods: {
    generatePasswordFx(){
        var number = this.generatePassword(10);

        this.password = number;
    },
    submitForm(){
      const form = document.querySelector("#form");
      form.addEventListener("submit", e => {
        e.preventDefault();
        const fd = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.addEventListener("load", e => {

          if(e.currentTarget.status === 200)
            this.$router.replace({name: 'AdminList'})

          if(e.currentTarget.status === 400){
            this.error = JSON.parse(e.target.responseText).error;

            setTimeout(() => {
              this.error = null;
            }, 5000)
          }


        });
        xhr.addEventListener("error", e => {
          console.log(e);
          this.error = JSON.parse(e.target.responseText).error;
        });
        xhr.open("POST", form.action);
        xhr.setRequestHeader('Accept-Language', session.locale.locale)
        xhr.setRequestHeader('Authorization', 'Bearer ' + window.auth.accessToken)
        xhr.send(fd);
      });
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/AdminCreate.vue